import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrency from '../../../../../../../components/formatted-currency';
import { useAdditionalUserCountCostForBillingPlanId } from '../../../../hooks/use-plan-details';

import { messages } from './messages';

import style from '../plan-details.module.less';

/**
 * @param {object} props
 * @param {string} props.billingPlanId
 * @param {number} props.additionalUsers
 * @returns {React.JSX.Element}
 */
export const UserCost = ({ billingPlanId, additionalUsers }) => {
  const cost = useAdditionalUserCountCostForBillingPlanId(billingPlanId, additionalUsers);

  const message = cost?.value ? (
    <FormattedMessage
      {...messages.userCountAdditionalCost}
      values={{
        cost: <FormattedCurrency currencyCode={cost?.code} value={cost.value} />,
      }}
    />
  ) : (
    <FormattedMessage {...messages.includedAbbreviation} />
  );

  return <Text className={style['plan-option-content-cost']} element='span' textType={TextType.Caption} value={message} />;
};
